import React from 'react';
import {Box, Stack, styled} from '@mui/material';
import {Body, designSystemToken} from '@lightricks/react-design-system';
import ErrorsTooltip from '@contentlab/components/asset-card/components/errors-tooltip';
import {AssetError} from '@contentlab/types/projectProps';
import translate from '@/utils/translate';
import GradientProgressBar from '@/components/gradient-progress-bar';

const Container = styled(Stack)(() => ({
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '6px',
}));

function AssetUploadProgressBar({
  progress,
  ready,
  errors,
}: {
  progress: number;
  ready: boolean;
  errors?: AssetError[];
}) {
  if (errors?.length) {
    return (
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-end',
          paddingInlineEnd: '8px',
        }}
      >
        <ErrorsTooltip errors={errors} />
        <Body size="md" color={designSystemToken('semantic.fg.danger')}>
          {translate('Failed count', {
            postProcess: 'interval',
            count: errors.length,
          })}
        </Body>
      </Container>
    );
  }
  if (ready) {
    return (
      <Container paddingInlineEnd="8px">
        <Body size="md" color={designSystemToken('semantic.fg.secondary')}>
          {translate('Ready')}
        </Body>
      </Container>
    );
  }
  return (
    <Container>
      <Body
        size="md"
        color={designSystemToken('semantic.fg.secondary')}
        textAlign="right"
      >
        {translate('uploading_percentage', {
          progress,
        })}
      </Body>
      <Box width="100px" alignSelf="flex-end">
        <GradientProgressBar
          initialValue={progress || 0}
          value={progress || 0}
          backgroundColor={designSystemToken('semantic.bg.neutral-secondary')}
          fillColor={designSystemToken('semantic.fg.secondary')}
        />
      </Box>
    </Container>
  );
}

export default AssetUploadProgressBar;
